import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { CapQuestLogo } from '../../assets/icons/index';
import Button from '../../components/button/index';
import { guides } from './guides/index';
import { ModifyGuideTab } from './modify-guide.types';

export const ModifyGuide: FC = () => {
  const navigate = useNavigate();
  const { tab = ModifyGuideTab.IMPORT_GRANTS } = useParams<{ tab?: ModifyGuideTab }>();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentGuideType = tab;

  const currentGuide = guides[currentGuideType].guide;

  const currentGuideSteps = guides[currentGuideType].stepsTitles;

  const currentGuideTitle = guides[currentGuideType].guideTitle;

  return (
    <div className="relative flex h-screen w-full flex-col gap-2 bg-brand-25">
      <div className="flex w-full justify-between rounded-b-3xl bg-white px-8 py-3">
        <div className="flex items-center gap-2" onClick={() => navigate('/')}>
          <CapQuestLogo size={32} />
          <span className="text-xl font-semibold text-gray-700">CapQuest</span>
        </div>
      </div>
      <div className="flex h-full w-full flex-col gap-8 rounded-t-3xl bg-white px-8 py-4">
        <div className="flex h-[38px] w-full gap-2 border-b-[1px] border-gray-200">
          <Button
            className={twMerge(
              'flex h-full w-fit rounded-none border-b-2 border-transparent pb-4 text-sm font-[450] text-gray-400',
              'border-brand-700 font-[550] text-brand-700',
            )}
            styleType="NONE"
          >
            {currentGuideTitle}
          </Button>
        </div>
        <div className="flex w-full gap-6">
          <div className="flex h-fit max-h-[80vh] w-max flex-col gap-2 rounded-md py-4 shadow-sm">
            <span
              className="text-nowrap px-6 py-2 text-label-sm font-bold uppercase text-gray-400"
              style={{ letterSpacing: '1px' }}
            >
              On this page
            </span>
            <div className="flex h-full w-full flex-col gap-[2px] overflow-y-auto">
              {currentGuideSteps.map(({ title }, i) => (
                <div
                  className="w-full cursor-pointer text-nowrap p-2 pl-6 pr-12 text-xs font-[450] text-gray-600 transition-all duration-300 hover:bg-brand-25 hover:font-semibold hover:text-brand-700"
                  key={`${title}-${i + 1}`}
                  onClick={() => scrollToSection(`main-step-${i + 1}`)}
                >
                  {`Step ${i + 1}: ${title}`}
                </div>
              ))}
              <div
                className="w-full cursor-pointer text-nowrap p-2 pl-6 pr-12 text-xs font-[450] text-gray-600 transition-all duration-300 hover:bg-brand-25 hover:font-semibold hover:text-brand-700"
                onClick={() => scrollToSection(`key-notes-and-tips`)}
              >
                Key Notes and Tips
              </div>
            </div>
          </div>
          <div className="flex h-[80vh] w-full flex-col gap-4 overflow-y-auto rounded-md p-4 shadow-sm">
            {currentGuide}
          </div>
        </div>
      </div>
    </div>
  );
};
